import React, { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import { Alert } from "react-bootstrap";

import "./ErrorAlert.scss";

interface ErrorAlertProps {
    messageId: string;
    message?: string;
    details?: string;
}

const ErrorAlert: FunctionComponent<ErrorAlertProps> = props => {
    return (
        <Alert variant="danger" className="error_alert">
            <div className="error_alert_message">
                {props.messageId ? <FormattedMessage id={props.messageId} /> : props.message}
            </div>
            {!!props.details && <div className="error_alert_details">{props.details}</div>}
        </Alert>
    );
};

export default ErrorAlert;
